import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="grain-bg min-h-[calc(100vh-68px)] grid place-items-center px-4">
      <div className="max-w-md w-full rounded-3xl border border-parchment-200 bg-white p-10 text-center" data-testid="payment-cancel">
        <span className="grid place-items-center h-16 w-16 rounded-2xl bg-parchment-100 text-ink-500 mx-auto"><XCircle className="h-9 w-9" /></span>
        <h1 className="mt-5 font-serif text-2xl font-semibold text-forest-900">Checkout cancelled</h1>
        <p className="mt-2 text-ink-600">No charge was made. You can unlock the Case Pass any time.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button onClick={() => navigate("/upgrade")} className="rounded-full bg-forest-800 hover:bg-forest-900 text-parchment-50">View Case Pass</Button>
          <Button onClick={() => navigate("/dashboard")} variant="outline" className="rounded-full border-parchment-200">Back to vault</Button>
        </div>
      </div>
    </div>
  );
}
